module.exports = __webpack_public_path__ + "static/img/4.ce1fc26f.jpg";